function videoPlayOnView() {
  // Función para cargar un video sin reproducirlo automáticamente
  function loadVideo(videoElement) {
    if (!videoElement) return;

    // Si el video no tiene una fuente activa, la cargamos desde data-src.
    if (!videoElement.currentSrc) {
      const source = videoElement.querySelector('source[data-src]');
      if (source) {
        const videoSrc = source.getAttribute('data-src');
        if (videoSrc) {
          source.src = videoSrc; // Asignar al <source>
          source.removeAttribute('data-src'); // Limpiar el atributo temporal
          videoElement.setAttribute('preload', 'metadata'); // Cargar solo metadata
          videoElement.load(); // Pedir al <video> que cargue desde su <source>
          
          // CRÍTICO: Pausar explícitamente después de cargar para evitar autoplay
          videoElement.pause();
          videoElement.currentTime = 0;
        }
      }
    }
  }

  // Función para cargar y reproducir un video bajo demanda.
  function loadAndPlay(videoElement) {
    if (!videoElement) return;

    loadVideo(videoElement);
    
    // Esperar a que el video esté listo antes de reproducir
    if (videoElement.readyState >= 2) {
      videoElement.play().catch(() => {});
    } else {
      videoElement.addEventListener('loadeddata', () => {
        videoElement.play().catch(() => {});
      }, { once: true });
    }
  }

  // Cargar todos los videos de las cards al inicio (en pausa)
  document.querySelectorAll('.card').forEach(card => {
    const thumbVideo = card.querySelector('.thumb video');
    loadVideo(thumbVideo);
  });

  // Reproducir video al hacer hover
  document.querySelectorAll('.card').forEach(card => {
    card.addEventListener('mouseenter', () => {
      // 1. Reproducir el video de la miniatura
      const thumbVideo = card.querySelector('.thumb video');
      if (thumbVideo) {
        thumbVideo.play().catch(() => {});
      }

      // 2. Cargar y reproducir el video de fondo principal
      const mediaSlug = card.getAttribute('data-media');
      const videoBack = document.getElementById('video-back');
      if (videoBack) {
        videoBack.querySelectorAll('.media').forEach(m => m.classList.remove('is-active'));
        const targetMedia = videoBack.querySelector(`.media[data-media="${mediaSlug}"]`);
        if (targetMedia) {
          const backgroundVideo = targetMedia.querySelector('video');
          loadAndPlay(backgroundVideo);
          targetMedia.classList.add('is-active');
        }
      }
    });

    card.addEventListener('mouseleave', () => {
      // Pausar el video de la miniatura al salir del hover
      const thumbVideo = card.querySelector('.thumb video');
      if (thumbVideo) {
        thumbVideo.pause();
        thumbVideo.currentTime = 0; // Reiniciar al inicio
      }
    });
  });
}

export default videoPlayOnView;